import { useNavigate } from 'react-router-dom';
import { Clock, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/hooks/useSubscription';

/**
 * Slim countdown strip shown at the top of the dashboard while a company
 * is still on its free trial. Hidden once they subscribe.
 */
export const TrialBanner = () => {
  const navigate = useNavigate();
  const { isLoading, isSubscribed, isOnTrial, daysLeft } = useSubscription();

  if (isLoading || isSubscribed || !isOnTrial) return null;

  const urgent = daysLeft <= 3;

  return (
    <div
      className={`mb-6 rounded-xl border p-4 flex flex-col sm:flex-row sm:items-center gap-3 ${
        urgent ? 'border-orange-500/40 bg-orange-500/10' : 'border-primary/30 bg-primary/5'
      }`}
    >
      <div className={`h-10 w-10 rounded-lg flex items-center justify-center shrink-0 ${urgent ? 'bg-orange-500/20 text-orange-500' : 'bg-primary/10 text-primary'}`}>
        {urgent ? <Clock className="h-5 w-5" /> : <Sparkles className="h-5 w-5" />}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold">
          {daysLeft === 0
            ? 'Your free trial ends today'
            : `${daysLeft} day${daysLeft === 1 ? '' : 's'} left in your free trial`}
        </p>
        <p className="text-sm text-muted-foreground">
          Pick a plan to keep your logs, reports and audit history active. From $34.99 per location a month.
        </p>
      </div>
      <Button onClick={() => navigate('/pricing')} className="shrink-0">
        Choose a plan
      </Button>
    </div>
  );
};

export default TrialBanner;
